package br.com.logicalside.proposes

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

/**
 * @property nearBackground A useful color to apply to a container that should differentiate itself from the background
 *   but just a little.
 */
class SitePalette(
    val nearBackground: Color,
    val brand: Brand,
    val onBackground: Color,
    val backgroundVariant: Color,
    val neutral: Neutral = Neutral(),
) {
    class Brand(
        val primary: Color = Color.rgb(0x3C83EF),
        val accent: Color = Color.rgb(0xF3DB5B),
    )

    class Neutral(
        val n10: Color = Color.rgb(0xF7F7F7),
        val n20: Color = Color.rgb(0xEFEFEF),
        val n30: Color = Color.rgb(0xD9D8DB),
        val n40: Color = Color.rgb(0xC8C7CC),
        val n50: Color = Color.rgb(0xAAA9B0),
        val n60: Color = Color.rgb(0x73747D),
        val n70: Color = Color.rgb(0x63636E),
        val n80: Color = Color.rgb(0x4A4B54),
        val n90: Color = Color.rgb(0x39383D),
        val n100: Color = Color.rgb(0x39383D)
    )
}

object SiteColors {
    val n10: Color = Color.rgb(0xF7F7F7)
    val n20: Color = Color.rgb(0xEFEFEF)
    val n30: Color = Color.rgb(0xD9D8DB)
    val n40: Color = Color.rgb(0xC8C7CC)
    val n50: Color = Color.rgb(0xAAA9B0)
    val n60: Color = Color.rgb(0x73747D)
    val n70: Color = Color.rgb(0x63636E)
    val n80: Color = Color.rgb(0x4A4B54)
    val n90: Color = Color.rgb(0x39383D)
    val n100: Color = Color.rgb(0x212121)
}

object SitePalettes {
    val light = SitePalette(
        nearBackground = Color.rgb(0xF4F6FA),
        brand = SitePalette.Brand(
            primary = Color.rgb(0xD03E43),
            accent = Color.rgb(0xFCBA03),
        ),
        onBackground = SiteColors.n100,
        backgroundVariant = SiteColors.n20
    )
    val dark = SitePalette(
        nearBackground = Color.rgb(0x13171F),
        brand = SitePalette.Brand(
            primary = Color.rgb(0xe8585d),
            accent = Color.rgb(0xF3DB5B),
        ),
        onBackground = SiteColors.n10,
        backgroundVariant = SiteColors.n100
    )
}

fun ColorMode.toSitePalette(): SitePalette {
    return when (this) {
        ColorMode.LIGHT -> SitePalettes.light
        ColorMode.DARK -> SitePalettes.dark
    }
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.light.background = Color.rgb(0xFAFAFA)
    ctx.theme.palettes.light.color = Colors.Black
    ctx.theme.palettes.dark.background = Color.rgb(0x141414)
    ctx.theme.palettes.dark.color = Colors.White
}
